import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    getListObjects,
    createObject,
    deleteObject,
    updateObjectById,
    getListObjectsByName
} from '../../services/apis/ObjectAPIServices'
import { uploadAvatar } from '../../services/apis/UserAPIServices'
import { message } from 'antd'
import { HandleErrorCode } from '../handleErrorCode/index'
function* saga_LoadListObjects(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(
            state => state.component_select_object.pageIndex
        )
        let page_size = yield select(
            state => state.component_select_object.pageSize
        )
        let status = yield select(
            state => state.component_select_object._status
        )
        let textSearch = yield select(
            state => state.component_select_object.lastTextSearch
        )

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status != null) status = params.status

        const response = yield call(
            getListObjects,
            page_number,
            page_size,
            status,
            ''
        )
        console.log('respone data object', response )

        if (response.error.code === 200) {
            let objects = response.data
            let total = response.total

            if (objects.length > page_size)
                objects = objects.slice(0, page_size)

            yield put(actions.action.loadListObjectsSuccess(objects))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                })
            )
        } else {
            console.error(
                'Get list object call API  server error: ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('get list object error : ', ex.messag)
    }
}

function* saga_SaveCurrentObject(action) {
    try {
        
        const { extendData } = action.payload
        let currentObject = yield select(state => state.component_select_object.currentObject)
        currentObject = {
            ...currentObject,
            ...{
                ext_data: {lstExtendData: JSON.stringify(extendData)}
            },
        }
        const avatar_file = yield select(state => state.component_select_object.avatar_file)
        
        // upload avatar
        try {
            if (avatar_file != null) {
                const responseUploadAvatar = yield uploadAvatar(avatar_file)
                const avatar = responseUploadAvatar.uploaded_files[0]
                currentObject = {
                    ...currentObject,
                    ...{
                        avatar,
                    },
                }
            }
        } catch {}
        console.log('current object', currentObject)

        // put to server
        let response = ''
        if (currentObject.object_id === 0)
            // create object
            response = yield call(createObject, currentObject)
        // update object
        else
            response = yield call(
                updateObjectById,
                currentObject.object_id,
                currentObject
            )

        if (response.error.code === 200) {
            if (currentObject.object_id === 0)
                message.success('Thêm đối tượng thành công')
            else message.success('Cập nhật thông tin đối tượng thành công')

            yield put(actions.action.loadListObject({}))
        } else {
            HandleErrorCode(response.error.code)
            console.log(
                'Save current object call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Save current object error : ', ex.message)
    }
}

function* saga_DeleteObject(action) {
    try {
        const { objectId } = action.payload
        const response = yield call(deleteObject, objectId)

        if (response.error.code === 200) {
            message.success('Xoá đối tượng thành công')

            yield put(actions.action.loadListObject({}))
        } else {
            HandleErrorCode(response.error.code)
        }
    } catch (ex) {
        console.error('Delete object error : ', ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload

        yield put(
            actions.action.loadListObject({
                page_number: 1,
                page_size: pageSize,
            })
        )
    } catch (ex) {
        console.error('Change page object size error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload

        yield put(actions.action.loadListObject({ page_number: pageIndex }))
    } catch (ex) {
        console.log('Change current object page error : ', ex.message)
    }
}

function* saga_SearchObject() {
    try {
        let page_number = 1
        let page_size = yield select(
            state => state.component_select_object.pageSize
        )
        let status = yield select(
            state => state.component_select_object._status
        )
        let textSearch = yield select(
            state => state.component_select_object.textSearch
        )

        const response = yield call(
            getListObjects,
            page_number,
            page_size,
            status,
            textSearch
        )

        if (response.error.code === 200) {
            let objects = response.data
            let total = response.total

            if (objects.length > page_size)
                objects = objects.slice(0, page_size)

            yield put(actions.action.loadListObjectsSuccess(objects))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    pageIndex: 1,
                })
            )
        } else {
            yield put(actions.action.loadListObjectsSuccess([]))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total: 0,
                    pageIndex: 0,
                })
            )
        }
    } catch (ex) {
        console.log('Search object error : ', ex.message)
    }
}
function* saga_searchSuggestion(action) {
    try {
        let {textSearch} = action.payload

        const response = yield call(
            getListObjectsByName,
            1,
            10,
            0,
            textSearch
        )
        if (response.error.code === 200) {
            yield put(actions.action.getSuggestionDataDone(response.data))
            
        }else{
            yield put(actions.action.getSuggestionDataDone([]))
        }
    } catch (ex) {
        console.log('Search suggestion object error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_OBJECTS, saga_LoadListObjects)
    yield takeEvery(actions.type.SAVE_CURRENT_OBJECT, saga_SaveCurrentObject)
    yield takeEvery(actions.type.DELETE_OBJECT, saga_DeleteObject)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.SEARCH_OBJECT, saga_SearchObject)
    yield takeEvery(actions.type.GET_SUGGESTION_DATA, saga_searchSuggestion)

}

export default function* objectsSaga() {
    yield all([fork(listen)])
}
